import './includes.js'

import {AddToBasketConfirmation} from './AddToBasketConfirmation.js';
import {AddToBasketPerformanceMarketing} from './AddToBasketPerformanceMarketing.js';
import {AppsApi} from './AppsApi.js';
import {sheetV1} from "@otto-ec/otto-components/sheet";

/*🤫*/
/*🤫*/
AddToBasketConfirmation.sheetV1 = sheetV1;
new AddToBasketConfirmation(window.o_order.tracking, new AddToBasketPerformanceMarketing()).initialize();

new AppsApi().initialize();
